import React from 'react';
import { CalendarRangeIcon, ClipboardCheckIcon, GuitarIcon, ListMusicIcon, Music2Icon, MusicIcon } from 'lucide-react';
import { Reveal } from './Reveal';
interface Content {
  icon: typeof MusicIcon;
  title: string;
  description: string;
  color: string;
  bullet: string;
  items?: string[];
}
const contents: Content[] = [{
  icon: MusicIcon,
  title: '6 Tomos de Primaria',
  description: 'Progresión completa de 6 a 12 años',
  color: 'bg-brand-blue/10 text-brand-blue',
  bullet: 'text-brand-blue',
  items: ['Sonido y Ritmo', 'Compás y Orquesta', 'Notas y Folclore', 'Escalas y Géneros', 'Formas y Jazz', 'Tecnología y Proyecto']
}, {
  icon: Music2Icon,
  title: '6 Tomos de Secundaria',
  description: 'Progresión completa de 13 a 18 años',
  color: 'bg-brand-purple/10 text-brand-purple',
  bullet: 'text-brand-purple',
  items: ['Elementos del Sonido', 'Escalas y Estilos', 'Folclore y Rock Nacional', 'Armonía y Producción', 'Armonía Avanzada', 'Composición y Proyecto Final']
}, {
  icon: CalendarRangeIcon,
  title: 'Planificación Anual Completa',
  description: 'Todo el ciclo lectivo ya organizado',
  color: 'bg-brand-orange/10 text-brand-orange',
  bullet: 'text-brand-orange'
}, {
  icon: ListMusicIcon,
  title: 'Actividades Paso a Paso',
  description: 'Cantar, tocar, crear y escuchar',
  color: 'bg-brand-green/10 text-brand-green',
  bullet: 'text-brand-green'
}, {
  icon: ClipboardCheckIcon,
  title: 'Evaluaciones y Rúbricas',
  description: 'Instrumentos de evaluación por nivel',
  color: 'bg-brand-pink/10 text-brand-pink',
  bullet: 'text-brand-pink'
}, {
  icon: GuitarIcon,
  title: 'Proyectos Musicales Prácticos',
  description: 'Para aplicar lo aprendido en el aula',
  color: 'bg-brand-teal/10 text-brand-teal',
  bullet: 'text-brand-teal'
}];
export function KitContentsSection() {
  return <section className="bg-brand-alt px-4 py-20 md:py-28" data-id="element-104" data-mp="3rl1s7jtsu2s2">
      <Reveal className="mx-auto max-w-5xl" data-id="element-105" data-mp="d60wa9ic58o">
        <div className="mb-12 text-center" data-id="element-106" data-mp="cwailkjvw2g">
          <p className="mb-3 text-xs font-extrabold tracking-[0.18em] text-brand-teal" data-id="element-107" data-mp="3htxcuj07ofwp">
            TODO LO QUE INCLUYE
          </p>
          <h2 className="text-3xl font-black text-brand-blue md:text-4xl" data-id="element-108" data-mp="3mrywb51juh8p">
            🎼 ¿Qué Incluye el Pack Música Lista?
          </h2>
        </div>
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-109" data-mp="38vlpcpun5y8h">
          {contents.map(({
          icon: ContentIcon,
          title,
          description,
          color,
          bullet,
          items
        }) => <article key={title} className="rounded-2xl border border-brand-dark bg-brand-main p-7 text-center" data-id="element-110" data-mp="2ywmdyzihrohs">
              <span className={`mx-auto flex h-14 w-14 items-center justify-center rounded-2xl ${color}`} data-id="element-111" data-mp="x3yb4r9rf32j">
                <ContentIcon className="h-7 w-7" strokeWidth={1.75} aria-hidden="true" data-id="element-112" data-mp="123b4zvz1taem" />
              </span>
              <h3 className="mt-5 text-xl font-bold text-brand-blue" data-id="element-113" data-mp="2mk2a84md11hp">{title}</h3>
              <p className="mt-2 text-sm text-brand-gray" data-id="element-114" data-mp="2hm0lp46609yu">{description}</p>
              {items && <ul className="mt-4 space-y-1.5 border-t border-brand-dark pt-4 text-left" data-id="element-115" data-mp="2wb58kynwn2da">
                  {items.map(item => <li key={item} className="flex items-start gap-2 text-xs font-semibold text-brand-text" data-id="element-116" data-mp="2ric3g9oixs0o">
                      <span className={`mt-[2px] ${bullet}`} aria-hidden="true" data-id="element-117" data-mp="359i9komb6nwj">
                        ♪
                      </span>
                      {item}
                    </li>)}
                </ul>}
            </article>)}
        </div>
      </Reveal>
    </section>;
}